import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const fontBold = {
  whiteSpace: 'pre-wrap',
  fontWeight: 700,
  lineHeight: '14.4px',
};

type TableInformationProps = {
  items: any[];
  title: string;
};

const TableInformation: React.FC<TableInformationProps> = (props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' },
      }}
    >
      <Table
        stickyHeader
        sx={{
          width: '100%',
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #0000001f',
            height: '12.7mm',
            p: '0 4.2333mm',
          }
        }}
        aria-label='simple table'>
        <TableHead >
          <TableRow hover >
            <TableCell
              align={'center'}
              colSpan={2}
              sx={{ bgcolor: 'primary.light' }}
            >
              <Typography
                sx={{
                  ...fontBold,
                  fontSize: '18px',
                  letterSpacing: '0.5em'
                }}>
                {props.title}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.items.map((item, index: number) => (
            <TableRow
              hover
              key={index}
              sx={{
                '& .MuiTableCell-root.MuiTableCell-body': {
                  py: '1.0583mm',
                  px: '0',
                  borderBottom: '1px solid #0000001f',
                },
                '&:last-child td, &:last-child th': { border: '0px !important' },
                height: '12.7mm',
              }}
            >
              <TableCell component='td' scope='row'>
                <Typography
                  sx={{
                    ...fontBold,
                    fontSize: '13px'
                  }}>
                  {item.label}
                </Typography>
              </TableCell>
              <TableCell component='td' scope='row'>
                <Typography
                  sx={{
                    ...fontBold,
                    fontSize: '13px',
                    fontWeight: 500,
                    display: 'flex',
                    justifyContent: 'right'
                  }}>
                  {item.content}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableInformation;
